import React from 'react'
import getConfig from 'next/config'
import { ConfigProvider } from '@ntuctech/tangram-web'
import Router from 'next/router'
import { get, headers } from '../../lib/fetch'

import GlobalContext from '../../components/GlobalContext'
import { AccountConsumer } from '../../components/AccountProvider'
import { EventTrackingConsumer } from '../../components/EventTrackingProvider'
import DigitalClubEntryPoint from '../../components/DigitalClub/DigitalClubEntryPoint/DigitalClubEntryPoint'
import { getUserDcEligibility } from '../../utils/constants/dc_free_trial'
import tangramNextConfig from '../../lib/tangramNextConfig'
import { SPLIT_FEATURES } from '../../utils/constants/feature'
import { getConfigFor } from '../../utils/configService'
import DigitalClubEntryPointNew from '../../components/DigitalClub/DigitalClubEntryPoint/DigitalClubEntryPointNew'

const {
  publicRuntimeConfig: { LOYALTY_API },
} = getConfig()

const MembershipRegistrationWrapper = props => {
  return (
    <ConfigProvider
      tokens={tangramNextConfig}
      experimental={{
        Text: true,
        Title: true,
        Link: true,
        Price: true,
        IconButton: true,
        Modal: true,
      }}
    >
      <GlobalContext.Consumer>
        {({ remoteConfig }) => (
          <EventTrackingConsumer>
            {({ track }) => (
              <AccountConsumer>
                {({ isLoggedIn, login }) =>
                  props.isAnnualMembershipEnabled ? (
                    <DigitalClubEntryPointNew
                      {...props}
                      standAlonePage={true}
                    />
                  ) : (
                    <DigitalClubEntryPoint
                      {...props}
                      standAlonePage={true}
                      remoteConfig={remoteConfig}
                      isLoggedIn={isLoggedIn}
                      login={login}
                      track={track}
                      getDcFreeTrialEligibility={getUserDcEligibility}
                    />
                  )
                }
              </AccountConsumer>
            )}
          </EventTrackingConsumer>
        )}
      </GlobalContext.Consumer>
    </ConfigProvider>
  )
}

MembershipRegistrationWrapper.getInitialProps = async ctx => {
  const { isEnabled: isAnnualMembershipEnabled } =
    getConfigFor(SPLIT_FEATURES.FE_DYNAMICS_DIGITAL_CLUB_ANNUAL_MEMBERSHIP) ||
    {}
  const { isEnabled: isAnnualMembershipTrackingEnabled } =
    getConfigFor(
      SPLIT_FEATURES.FE_DYNAMICS_DIGITAL_CLUB_ANNUAL_MEMBERSHIP_tracking
    ) || {}

  try {
    const dcmemberCheckRequest = get(
      `${LOYALTY_API}/memberships/status?programmeId=2`,
      {
        headers: headers(ctx, true),
      }
    )
    const [dcmemberCheckResponse] = await Promise.all([dcmemberCheckRequest])

    if (dcmemberCheckResponse?.dc?.active) {
      const membershipRegistrationUrl = isAnnualMembershipEnabled
        ? '/accounts?tab=membership'
        : '/membership/welcome'
      if (ctx.res) {
        ctx.res.writeHead(302, { Location: membershipRegistrationUrl })
        ctx.res.end()
      } else {
        Router.push(membershipRegistrationUrl)
      }
    }
    return {
      isDcMember: dcmemberCheckResponse?.dc?.active,
      isAnnualMembershipEnabled: isAnnualMembershipEnabled,
      isAnnualMembershipTrackingEnabled: isAnnualMembershipTrackingEnabled,
    }
  } catch (error) {
    return {
      isDcMember: false,
      isAnnualMembershipEnabled: isAnnualMembershipEnabled,
      isAnnualMembershipTrackingEnabled: isAnnualMembershipTrackingEnabled,
    }
  }
}

export default MembershipRegistrationWrapper
